import getTrackingContext from './getTrackingContext';
import setCorrelationId from './setCorrelationId';
import getMobiusEndpoint from './getMobiusEndpoint';
/**
 * @function setHostedFallback
 * @description Sets provided fallback href when hosted lead program is capped
 * @param {Node} ctaElement
 * @param {Object} config
 * @return {void}
 */
const setHostedFallback = async (ctaElement, config) => {
  const {
    cap,
    program,
    fallbackUrl,
    fallbackText,
    idToken = window?.HE?.publisher?.identityToken,
  } = config;
  const data = {
    criteria: {
      // eslint-disable-next-line radix
      programId: [parseInt(program)],
    },
    context: {
      media: 'premiumProfilePage',
    },
  };
  try {
    // check to see if program is capped
    const res = await fetch(
      `${getMobiusEndpoint(
        window.location.hostname
      )}/v1/inventory/programs/query?idToken=${idToken}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );
    if (res.status !== 200) throw res.statusText;
    const inventory = await res.json();
    const programMatch = inventory.find(
      // eslint-disable-next-line radix
      (p) => p.metadata.capId === parseInt(cap)
    );
    if (programMatch) {
      // program not capped - set hosted url
      const correlation = setCorrelationId();
      const { url: baseUrl, helid } = programMatch.product.destination;
      const url = `${baseUrl}?idToken=${idToken}&trafficSource=premiumProfilePage`;
      ctaElement.setAttribute(
        'href',
        `${url}&trackingContext=${encodeURIComponent(
          JSON.stringify(getTrackingContext())
        )}&helid=hld-${helid}&correlationId=${correlation}`
      );
    } else {
      // program is capped - set studymatch url
      ctaElement.setAttribute('href', fallbackUrl);
      ctaElement.replaceChildren(
        document.createTextNode(fallbackText || 'Search all programs')
      );
    }
  } catch (error) {
    // error checking if program is capped - set studymatch url
    console.error(error);
    ctaElement.setAttribute('href', fallbackUrl);
    ctaElement.replaceChildren(
      document.createTextNode(fallbackText || 'Search all programs')
    );
  }
};

export default setHostedFallback;
